import Rest from '../../Rest'

export default class CebasCredentialingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cebas/credentialings'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getCredentialingByLink(link: string) {
    return this.get(`/pub/${link}`)
  }

  initForm(link: string, email: string) {
    return this.post(`/init/${link}`, { email })
  }

  getCredentialingByEmailAndCode(link: string, email: string, code: string) {
    return this.get(`/pub/${link}/search?email=${email}&code=${code}`)
  }

  saveFormData(data: any) {
    return this.post('/save', data)
  }

  uploadFile(link: string, data: any) {
    return this.post(`/pub/${link}/upload`, data, { headers: {
      'Content-Type': 'multipart/form-data;'
    }}).then(data => {
      return data
    })
  }

  deleteFile (link: string, credentialingId: number, documentId: number, mediaId: number) {
    return this.delete(`/pub/${link}/documents/${documentId}`, {
      credentialing_id: credentialingId,
      media_id: mediaId
    })
  }

  addLinkedInstitution(link: string, data: any) {
    return this.post(`/pub/${link}/linked-institutions`, data, { headers: {
      'Content-Type': 'multipart/form-data;'
    }}).then(data => {
      return data
    })
  }

  deleteLinkedInstitution(link: string, credentialingId: number, institutionId: number) {
    return this.delete(`/pub/${link}/linked-institutions/${institutionId}`, {
      credentialing_id: credentialingId
    })
  }
}
